import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const key = `scroll-${location.pathname}`;
    const savedPosition = sessionStorage.getItem(key);
    const header = document.getElementById('header');

    if (savedPosition && !header) {
      // Restore position with multiple attempts
      const attempts = [0, 50, 100, 200];
      attempts.forEach(delay => {
        setTimeout(() => {
          window.scrollTo(0, Number.parseInt(savedPosition, 10));
        }, delay);
      });
    } else {
      window.scrollTo(0, 0);
    }

    const handleScroll = () => {
      sessionStorage.setItem(key, window.scrollY.toString());
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  return null;
};

export default ScrollManager;
